export default "__VITE_ASSET__BnOaGbH6__"